<ion-header>
  <ion-toolbar>
    <ion-title>{{ (editMode ? 'PLAYLISTS.EDIT_SONG' : 'GRAMMAR.SUBMIT_SONG') | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">{{ 'GRAMMAR.CANCEL' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list>
    <ion-item *ngIf="editMode || initialTitle">
      <ion-input
        label="{{ 'GRAMMAR.SONG_TITLE' | translate }}"
        label-placement="stacked"
        [(ngModel)]="title"
        type="text"
        maxlength="200">
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-input
        label="{{ 'GRAMMAR.YOUTUBE_URL' | translate }} *"
        label-placement="stacked"
        [(ngModel)]="youtubeUrl"
        type="url"
        placeholder="https://www.youtube.com/watch?v=..."
        maxlength="2048">
      </ion-input>
    </ion-item>
    <div *ngIf="errors.youtubeUrl" class="error-message">{{ errors.youtubeUrl }}</div>

    <ion-item>
      <ion-textarea
        label="{{ 'GRAMMAR.NOTE' | translate }}"
        label-placement="stacked"
        [(ngModel)]="note"
        [rows]="editMode ? 16 : 6"
        [autoGrow]="true"
        placeholder="Supports markdown — **bold**, *italic*, lists, headers, links…"
        maxlength="50000">
      </ion-textarea>
    </ion-item>
  </ion-list>

  <!-- Fetch Captions — only available in edit mode (needs a songId) -->
  <div *ngIf="editMode" class="transcript-section">
    <ion-button expand="block" fill="outline" color="medium" (click)="fetchTranscript()" [disabled]="fetchingTranscript || !youtubeUrl.trim()">
      <ion-spinner *ngIf="fetchingTranscript" name="crescent" slot="start"></ion-spinner>
      <ion-icon *ngIf="!fetchingTranscript" name="closed-captioning-outline" slot="start"></ion-icon>
      {{ fetchingTranscript ? ('PLAYLISTS.FETCHING_CAPTIONS' | translate) : ('PLAYLISTS.FETCH_CAPTIONS' | translate) }}
    </ion-button>

    <div *ngIf="transcriptStatus === 'success'" class="transcript-result transcript-success">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      {{ transcriptMessage }}
      <p class="transcript-preview">{{ transcriptPreview }}</p>
    </div>
    <div *ngIf="transcriptStatus === 'error'" class="transcript-result transcript-error">
      <ion-icon name="alert-circle-outline"></ion-icon>
      {{ transcriptMessage }}
    </div>
  </div>

  <div class="submit-container">
    <ion-button expand="block" (click)="submit()" [disabled]="submitting">
      <ion-spinner *ngIf="submitting" name="crescent"></ion-spinner>
      <span *ngIf="!submitting">{{ 'GRAMMAR.SUBMIT' | translate }}</span>
    </ion-button>
  </div>
</ion-content>
